<template>
  <div class="row align-center">
    <div class="small-10 medium-10 large-10 columns">
        <div class="row">
          <div class="small-12 small-centered medium-6 large-4 columns director_f" v-if="texto.length > 0">
            <PresidenteImage :imagem="imagem"/>
          </div>
          <div class="small-12 small-centered medium-12 columns director_f2"
            :class="{'large-8': texto.length > 0, 'large-12': texto.length == 0}">
            <TextoPresidente
                v-if="texto.length > 0"
                :faculdadename="$store.state.faculdadename"
                :texto="texto" />
            <PresidenteData
                :twitter="twitter"
                :cargo="cargo"
                :nome="nome"
                :email="email"
                :emailsec="emailsec"/>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import axios from "../../axios";
import PresidenteData from "./PresidenteData.vue";
import PresidenteImage from "../../components/PresidenteImage.vue";
import TextoPresidente from "../../components/TextoPresidente.vue";

export default {
  name: "PresidenteInfo",
  inject:["id","i18n"],
  components:{
    PresidenteData,
    PresidenteImage,
    TextoPresidente
  },
  data(){
    return {
      nome: "",
      texto:"",
      imagem: "",
      cargo: "",
      email: this.$store.state.faculdade.email,
      emailsec: "",
      twitter:""
    }
  },
  created() {
    axios.get(`/faculdades/${this.id}/presidente?idioma=${this.language}`).then(data => {
      const cargo = data.data;
      this.nome = cargo.Pessoa.name;
      this.cargo = cargo.Tipo;
      this.email = cargo.Email;
      this.imagem = cargo.imagem;

    }).catch(error => console.log(error))
  },
  updated() {
    this.texto = this.$store.state.faculdade.textopres;
    this.email = this.$store.state.faculdade.email;
    this.twitter = this.$store.state.faculdade.twitter;
  }
}
</script>

<style scoped lang="scss">
@import "../../global";

.row .row{
  margin-left:0;
  margin-right: 0;
}

.r-15-0{
  margin-left: 15px;
  margin-right: 15px;
}


@media (max-width: 1024px) {
  .r-15-0 {
    margin: 0;
  }
}

/*115*/
.director_f {
  display: flex;
  flex-direction: column-reverse;
  padding-left: 0;
  padding-right: 0;
}

.director_f2 {
  position: relative;
  padding-left: 80px;
}


@media (max-width: 1200px) {
  .director_f2{
    padding-left: 60px;
  }
}

@media (max-width: 1024px) {
  .director_f2{
    margin-top: 70px;
  }
}















  /*1083*/
@media (min-width : 768px)
and (max-width : 1024px) {

  /*1162-1167*/
  .director_f2 .columns {
    padding-right: 0!important;
    padding-left: 0!important;
  }

  .director_f2 {
    padding-right: 0!important;
    padding-left: 0!important;
  }

}


@media (max-width: 839px) {

  .director_f2 {
    margin-top: 10px;
  }


}

@media (max-width: 767px) {

  /*1503*/
  .director_f2 .columns {
    padding-right: 0!important;
    padding-left: 0!important;
  }
  /*1508*/
  .director_f2 {
    padding-right: 0!important;
    padding-left: 0!important;
  }

}








</style>